import type { PostgrestError } from '@supabase/supabase-js'

export class LimitExceededError extends Error {
  constructor(message?: string) {
    super(message)
    this.name = 'LimitExceededError'
  }
}

export class UnsupportedFileTypeError extends Error {
  constructor(message?: string) {
    super(message)
    this.name = 'UnsupportedFileTypeError'
  }
}

export class InvalidStatusError extends Error {
  constructor(message?: string) {
    super(message)
    this.name = 'InvalidStatusError'
  }
}

export class DataNotFoundError extends Error {
  constructor(message?: string) {
    super(message)
    this.name = 'DataNotFoundError'
  }
}

// throwOnError()せずにconst { data, error }で受け取ったerrorはErrorインスタンスではなく
// プレーンなオブジェクトとなっているためinstanceofでは判定できない。
const isPostgrestError = (error: unknown): error is PostgrestError => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    'message' in error &&
    'details' in error &&
    'hint' in error
  )
}

type IpNotAllowedPostgrestError = PostgrestError & {
  code: 'ip_not_allowed'
}

// check_request_ipで返されるエラーかどうかを判定する
// 本当はエラークラスを定義してinstanceofで判定したいが、全てのSupabase clientの実行箇所で
// 判定してErrorをthrowする必要があるので抜け漏れが出そうだった。
// 他に良い方法が思いつかなかったので現状はcatch側でisIpAdressNotAllowedPostgrestErrorを使うようにしている。
export const isIpNotAllowedPostgrestError = (
  error: unknown
): error is IpNotAllowedPostgrestError => {
  return isPostgrestError(error) && error.code === 'ip_not_allowed'
}
